import useTranslation from "next-translate/useTranslation";
import range from 'lodash/range';


const NUMBER_OF_RATINGS = 5

export function useTranslatedRatingLabels() {
  const {t} = useTranslation('reviews')

  return range(1, NUMBER_OF_RATINGS + 1).map((order) => t(`modal.create-review.rating-${order}`))
}
